import React, { useState, useEffect } from "react";
import { Box, Button, TextField, Typography, Paper, Snackbar, Alert } from "@mui/material";
import { useNavigate, useLocation } from "react-router-dom";
import { createStoreCounter, updateStoreCounter } from "../../Apis/storecounterApi";

const StoreCounterForm = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const counterData = location.state?.counterData;
    const storeData = location.state?.storeData;
    const editMode = Boolean(counterData);
    const storeid = location.state?.storeId;
    const [storeId, setStoreId] = useState("");
    const [storeName, setStoreName] = useState("");
    const [counterName, setCounterName] = useState("");
    const [loading, setLoading] = useState(false);
    const [success, setSuccess] = useState(false);
    const [errorMsg, setErrorMsg] = useState("");



    useEffect(() => {
        if (editMode && counterData) {
            setStoreId(counterData.storeId);
            setStoreName(counterData.storeName || "");
            setCounterName(counterData.name);
        } else if (storeData) {
            setStoreId(storeData.id || storeData.storeId);
            setStoreName(storeData.name || storeData.storeName);
        }
    }, [editMode, counterData, storeData]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!counterName) {
            setErrorMsg("Please enter Counter Name.");
            return;
        }

        const data = { storeId: storeid, name: counterName };

        try {
            setLoading(true);
            if (editMode) {
                await updateStoreCounter(counterData.id, data);
            } else {
                await createStoreCounter(data);
            }
            setSuccess(true);
            setTimeout(() => navigate("/storecounter/list"), 1000);
        } catch (err) {
            setErrorMsg(editMode ? "Failed to update store counter." : "Failed to create store counter.");
        } finally {
            setLoading(false);
        }
    };

    return (
        <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", px: 3, py: 4 }}>
            <Paper sx={{ width: "40%", p: 5, borderRadius: 3, boxShadow: 6 }}>
                <Typography variant="h5" gutterBottom>
                    {editMode ? "Update Store Counter" : "Create Store Counter"}
                </Typography>
                <form onSubmit={handleSubmit}>
                    {/* Display Store Name (read-only) */}
                    <TextField
                        fullWidth
                        label="Store Name"

                        value={storeName}
                        InputProps={{ readOnly: true }}
                        sx={{ mb: 2, display: 'none' }}
                    />
                    {/* Counter Name */}
                    <TextField
                        fullWidth
                        label="Counter Name"
                        value={counterName}
                        onChange={(e) => setCounterName(e.target.value)}
                        required
                        sx={{ mb: 2 }}
                    />
                    <Button type="submit" variant="contained" fullWidth disabled={loading}>
                        {loading ? (editMode ? "Updating..." : "Creating...") : editMode ? "Update" : "Create"}
                    </Button>
                </form>

                <Snackbar
                    open={success}
                    autoHideDuration={3000}
                    onClose={() => setSuccess(false)}
                    anchorOrigin={{ vertical: "top", horizontal: "right" }}
                >
                    <Alert severity="success" variant="filled">
                        {editMode ? "Store counter updated successfully!" : "Store counter created successfully!"}
                    </Alert>
                </Snackbar>

                <Snackbar
                    open={!!errorMsg}
                    autoHideDuration={4000}
                    onClose={() => setErrorMsg("")}
                    anchorOrigin={{ vertical: "top", horizontal: "right" }}
                >
                    <Alert severity="error" variant="filled">
                        {errorMsg}
                    </Alert>
                </Snackbar>
            </Paper>
        </Box>
    );
};

export default StoreCounterForm;
